export default "__VITE_ASSET__DoLAlg0___"